import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/observable';
import { IUnfreezeDirectDebitContentsResult } from './interfaces/unfreeze-direct-debit-contents-result.interface';
import { AppConfigsService } from 'ClientApp/app/config/app-configs.service';
import {
    HttpService,
    IResponse,
    IResponseLower,
    IEmptyResult
} from 'ClientApp/app/shared/cardholders-core/services/http-service.service';
import { IUnfreezeDirectDebitRequest } from './interfaces/IUnfreezeDirectDebitResult';
import { DirectDebitService } from 'ClientApp/app/modules/direct-debit/services/direct-debit.service';

@Injectable()
export class UnfreezeDirectDebitService {
    formPopup = false;
    constructor(
        private httpSvc: HttpService,
        private appConfigsService: AppConfigsService,
        private dbSrv: DirectDebitService
    ) {}

    getContents(): Observable<IResponse<IUnfreezeDirectDebitContentsResult>> {
        return this.httpSvc.getWithSsrCache(
            `${this.appConfigsService.appConfigs.apiUrl}/registered/unfreezeDirectDebit/getContents`,
            'unfreezeDirectDebitContents'
        );
    }

    unfreeze(req: IUnfreezeDirectDebitRequest): Observable<IResponseLower<IEmptyResult>> {
        return this.httpSvc.postLower<IEmptyResult>(`${this.dbSrv.baseApi}/unfreezeDirectDebit`, req);
    }
}
